module.exports = __webpack_public_path__ + "public/SiteIcons/userViewProfile.svg?b36ee758";